export default "__VITE_ASSET__BdmL8MKR__"